import React, { Component } from "react";
import OtpInput from "react-otp-input";

export default class OTPView extends Component {
    state = { otp: "" };

    handleChange = (otp) => {
        this.setState({ otp });
        this.props.onChange(otp);
    };

    render() {
        return (
            <OtpInput
                value={this.state.otp}
                onChange={this.handleChange}
                numInputs={6}
                isInputNum={true}
                inputStyle={{
                    width: "2rem",
                    height: "2rem",
                    marginRight: 8,
                    border: "1px solid",
                }}
                containerStyle={{
                    justifyContent: "space-between",
                    maxWidth: 240,
                }}
            />
        );
    }
}
